export default __webpack_public_path__ + "static/Needs-Assessment-e6eaeb04f10619d0c2413727e443bc7f.webp";